import React from "react";
import "../App.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { postMaterialDeclaration, postMaterialDeclarationRemarks } from "../Actions/MaterialDeclarationAPI";
import API from "../helpers/api";
import axios from "axios";
import { toast } from "react-toastify";
import * as moment from 'moment';
import Moment from "moment";
import { getSixMonthReview, postSixMonthReview } from "../Actions/ShipViewAPI";
import AddIcon from "../UIComponents/AddIcon";

var today = new Date();
var currentDate = moment(today).format("DD MMM YYYY");

class ShipViewReview extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            reviewData:
            {
                revisionBySixMonthId: "",
                shipName: "",
                revisionNo: "",
                dateOfRevision: "",
                reviewedBy: "",
                areAllStaffConcernedFamiliarWithTheIhmpartI: "",
                isIhmpartIupdatedProperly: "",
                isListOfDeliveryRecorded: "",
                mdAndSdoCrecorded: "",
                isIhmcertificateValidAndNecessaryInspectionsAreCarried: "",
                areThereAnyAbnormality: "",
                others: "",
                isThereAnyChangesToIhmpartI: "",
                reviewObservationAndCorrectiveActions: ""
            }
        };
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        // const { dispatch, match } = this.props;
        // dispatch({ type: 'SubBannerTitle', data: "Material Declaration" });
        // if (match.params.shipId) {
        //     dispatch(getSixMonthReview(match.params.shipId));
        // }

    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { sixMonthReview } = nextProps;
        if (sixMonthReview) {
            prevState.reviewData = sixMonthReview;
        }
    }

    SubmitReview = () => {
        const { dispatch } = this.props;
        dispatch(postSixMonthReview(this.state));
    }

    onHandleInputChange(e) {
        const { dispatch } = this.props;
        let nodeName = e.target.name;
        if (nodeName === "MDoc") {
            this.state.declarationDetails.mdAttachmentName = e.target.files[0].name;
            this.state.mdocfile = e.target.files[0];
            this.setState({ declarationDetails: this.state.declarationDetails });
            let postItem = e.target.files[0];
            const data = new FormData()
            data.append('file', postItem)
            let url = `${API.AttachmentAPI}`;
            axios.post(url, data)
                .then((response) => {
                    dispatch({
                        type: "AttachmentUploadMDocSuccess",
                        data: response.data,
                    })
                })
                .catch((error) => {
                    dispatch({
                        type: "AttachmentUploadMDocFailure",
                        error: "ERROR"
                    })
                    toast.success('Document is already uploaded.Please upload different document', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                })
        } else if (nodeName === "SDoc") {
            this.state.declarationDetails.sdocAttachmentName = e.target.files[0].name;
            this.state.sdocfile = e.target.files[0];
            this.setState({ declarationDetails: this.state.declarationDetails });
            let postItem = e.target.files[0];
            const data = new FormData()
            data.append('file', postItem)
            let url = `${API.AttachmentAPI}`;
            axios.post(url, data)
                .then((response) => {
                    dispatch({
                        type: "AttachmentUploadSDocSuccess",
                        data: response.data,
                    })
                })
                .catch((error) => {
                    dispatch({
                        type: "AttachmentUploadSDocFailure",
                        error: "ERROR"
                    })
                    toast.success('Document is already uploaded.Please upload different document', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                })
        }
    }

    handleInputChange = (e) => {
        let nodeName = e.target.name;
        this.state[nodeName] = e.target.value;
        this.setState({});
    }

    hideSidePanel = () => {
        this.props.history.goBack();
        this.props.dispatch({ type: "ShowSidePan", data: false });
    }

    NewitemNav = () => {
        const { dispatch, match } = this.props;
        if (match.params.id) {
            this.props.history.push(`/Home/Ship/${match.params.id}/SixMonthReviewEdit`);
            this.props.dispatch({ type: "ShowSidePan", data: false });
        }
    };

    render() {
        const { reviewData } = this.state;

        return (
            <div className="full-height my-3">
                <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                    onClick={() => this.hideSidePanel()}
                >
                    &larr; Return
                        </button>
                <div className="card mt-2 MM-card-header mb-1">
                    <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                        <h5 className="card-title m-2" style={{ color: "092a51" }}>IHM Review</h5>
                        {/* <div className="m-1 flex" onClick={this.NewitemNav}>
                            <span className="card-title m-auto">Add</span><AddIcon />
                        </div> */}
                    </div>
                </div>
                <div className="panel-box p-3">
                    <div className="row mt-3">
                        {/* Product information Table */}
                        <div className="col-lg-12">
                            <table className="material-decalaration-table">
                                <tr>
                                    <th>Name of the ship: </th>
                                    <td contentEditable={false} onBlur={(e) => this.handleInputChange(e, "shipName")}>{this.state.reviewData.shipName}</td>
                                    <td rowSpan="2" contentEditable={false} onBlur={(e) => this.handleInputChange(e, "reviewedBy")}>{this.state.reviewData.reviewedBy}</td>
                                </tr>
                                <tr>
                                    <th>Date of Review: </th>
                                    <td contentEditable={false} onBlur={(e) => this.handleInputChange(e, "dateOfRevision")}>{Moment(new Date(Date.parse(this.state.reviewData.dateOfRevision))).format('DD MMM YYYY')}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2">Description</th>
                                    <th>Status</th>
                                </tr>
                                <tr>
                                    <th colSpan="2">Are all staff concerned familiar with the IHM Part-I and the relevant manuals are being kept properly? </th>
                                    <td contentEditable={false} onBlur={(e) => this.handleInputChange(e, "areAllStaffConcernedFamiliarWithTheIhmpartI")}>{this.state.reviewData.areAllStaffConcernedFamiliarWithTheIhmpartI}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2">Is IHM Part I – Updated properly? </th>
                                    <td contentEditable={false} onBlur={(e) => this.handleInputChange(e, "isIhmpartIupdatedProperly")}>{this.state.reviewData.isIhmpartIupdatedProperly}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2">MD and SDoC’s recorded and details maintained onboard? </th>
                                    <td contentEditable={false} onBlur={(e) => this.handleInputChange(e, "mdAndSdoCrecorded")}>{this.state.reviewData.mdAndSdoCrecorded}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2">Is IHM Certificate Valid and necessary inspections are carried out within the due date ? </th>
                                    <td contentEditable={false} onBlur={(e) => this.handleInputChange(e, "isIhmcertificateValidAndNecessaryInspectionsAreCarried")}>{this.state.reviewData.isIhmcertificateValidAndNecessaryInspectionsAreCarried}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2">Is List of delivery and dismantlement relating to works recorded and updated ? </th>
                                    <td contentEditable={false} onBlur={(e) => this.handleInputChange(e, "isListOfDeliveryRecorded")}>{this.state.reviewData.isListOfDeliveryRecorded}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2">Are there any abnormality as results of verification of each record observed during the review? </th>
                                    <td contentEditable={false} onBlur={(e) => this.handleInputChange(e, "areThereAnyAbnormality")}>{this.state.reviewData.areThereAnyAbnormality}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2">Others </th>
                                    <td contentEditable={false} onBlur={(e) => this.handleInputChange(e, "others")}>{this.state.reviewData.others}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2">Is there any changes to IHM Part I  </th>
                                    {this.state.reviewData.isThereAnyChangesToIhmpartI ?
                                    <td colSpan="2" contentEditable={false} onChange={(e) => this.handleInputChange(e, "isThereAnyChangesToIhmpartI")}>Yes</td>
                                    : <td colSpan="2" contentEditable={false} onChange={(e) => this.handleInputChange(e, "isThereAnyChangesToIhmpartI")}>No</td>}
                                        {/* <select className="table-editable-dropdown" value={this.state.reviewData.isThereAnyChangesToIhmpartI} onChange={(e) => this.handleInputChange(e, "isThereAnyChangesToIhmpartI")}>
                                            <option value=""></option>
                                            <option value="true">YES</option>
                                            <option value="false">NO</option>
                                        </select> */}
                                </tr>
                                <tr>
                                    <th colSpan="4">Review observation and corrective actions (if any): </th>
                                </tr>
                                <tr>
                                    <td colSpan="4" contentEditable={false} onBlur={(e) => this.handleInputChange(e, "reviewObservationAndCorrectiveActions")}>{this.state.reviewData.reviewObservationAndCorrectiveActions}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2">Designated Person (Name/Signature): </th>
                                    <td contentEditable={false} onBlur={(e) => this.handleInputChange(e, "productName")}>{ }</td>
                                </tr>
                                <tr>
                                    <th colSpan="2">Date:                                                                     </th>
                                    <td contentEditable={false} onBlur={(e) => this.handleInputChange(e, "productName")}></td>
                                </tr>
                                {/* <td  contentEditable={false} onBlur={(e) => this.handleInputChange(e, "productNumber")}></td>
                                    <td style={{ textAlignLast: "center" }}  contentEditable={false} onBlur={(e) => this.handleInputChange(e, "productQuantityAmount")}></td>
                                  
                                    <td  contentEditable={false} onBlur={(e) => this.handleInputChange(e, "productInfo")}></td>
                                </tr> */}
                            </table>
                        </div>
                    </div>

                    {/* <div className="row">
                        <div className={"col-lg-12 mt-4"}>
                            <div className=" search-btn-col" style={{ textAlign: "end" }}>
                                < button
                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                    type="submit" onClick={() => this.SubmitReview()}>
                                    Submit
                                </button>
                                <button
                                    className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                    type="button" onClick={() => this.CancelMaterialDeclaration()}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div >
        );
    }
}

function mapStateToProps(state) {
    return {
        MDocAttachment: state.MMPLDashboardReducer.MDocAttachment,
        SDocAttachment: state.MMPLDashboardReducer.SDocAttachment,
        PODetail: state.POViewReducer.PODetail,
        POLineItem: state.POViewReducer.POLineItem,
        sixMonthReview: state.ShipViewReducer.SixMonthReview || {},
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ShipViewReview)
);
